module.exports = __webpack_public_path__ + "files/d1f3a2f7ad44ccdddcc4fbd368e3a3b4.png";